// eslint-disable-next-line no-restricted-imports
import type { ErrorContext } from '@glovo/rum'
// eslint-disable-next-line no-restricted-imports
import { browserEventsRecorder, datadogRumIntegration, glovoRum } from '@glovo/rum'
import { setOnError, setOnFeatureInit } from '../error-tracking/event-handlers'
import { getNextHopProtocol, onBeforeSend } from './utils'
import { getAppContext, isSuperApp } from '@/superapp/use-cases/client'
import { getConfig } from '@/tools/config'

export const initRumIntegration = () => {
  const { env, version, rumApplicationId, rumClientToken, name } = getConfig()
  glovoRum.init({
    recorder: browserEventsRecorder(window),
    stackTraceLimit: 50,
    integrations: [
      datadogRumIntegration({
        applicationId: rumApplicationId,
        clientToken: rumClientToken,
        env: env,
        service: name,
        version: version,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        sessionSampleRate: isSuperApp() ? 100 : 15,
        sessionReplaySampleRate: 0,
        beforeSend: onBeforeSend,
      }),
    ],
  })

  glovoRum.setContext('nextHopProtocol', getNextHopProtocol())
  glovoRum.setContext('authenticated', false)
  glovoRum.setContext('address', false)
  glovoRum.setContext('appContext', getAppContext())

  setOnError((error, ctx) => {
    glovoRum.addError(error as Error, ctx as unknown as ErrorContext)
  })

  setOnFeatureInit((event, ctx) => {
    glovoRum.addAction(event, ctx)
  })
}
